import React, { useEffect } from "react";
import PropTypes from "prop-types";
import {
	Box,
	Divider,
	Drawer,
	List,
	Typography,
	IconButton,
} from "@mui/material";
import { Airplay, Home, Sun, UserCheck } from "react-feather";
import NavItem from "./NavItem";
import { Close, ListAlt } from "@mui/icons-material";
import { ReactComponent as Logo } from "../../../theme/icons/logo-nou.svg";
import { Link as RouterLink } from "react-router-dom";
import theme from "../../../theme";

const NavBar = ({ onMobileClose, openMobile }) => {
	const user = JSON.parse(localStorage.getItem("user")) || "";
	const items = [
		{
			href: "/admin/alumnes",
			icon: UserCheck,
			title: "Alumnes",
		},
		{
			href: "/admin/activitats",
			icon: ListAlt,
			title: "Activitats",
		},
		{
			href: "/admin/escoles",
			icon: Home,
			title: "Escoles",
		},
		{
			href: "/admin/buttons",
			icon: Airplay,
			title: "Botons",
		},
		{
			href: "/admin/inscrits",
			icon: Sun,
			title: "Casals",
		},
	];

	const content = (
		<Box height="100%" display="flex" flexDirection="column">
			<Box
				alignItems="center"
				display="flex"
				flexDirection="column"
				p={2}
			>
				<RouterLink to="/">
					<Logo
						fill={theme.palette.admin.primary}
						style={{ width: 120, height: 50, marginTop: 5 }}
					/>
				</RouterLink>
			</Box>
			<Divider />
			<Box p={2}>
				<List>
					{items?.map((item) => (
						<NavItem
							href={item.href}
							key={item.title}
							title={item.title}
							icon={item.icon}
						/>
					))}
				</List>
			</Box>
			<Box flexGrow={1} />
		</Box>
	);

	return (
		<>
			<Box sx={{ display: { md: "none", xs: "block" } }}>
				<Drawer
					anchor="left"
					onClose={onMobileClose}
					open={openMobile}
					variant="temporary"
				>
					<IconButton onClick={onMobileClose}>
						<Close />
					</IconButton>
					{content}
				</Drawer>
			</Box>
			<Box sx={{ display: { md: "block", xs: "none" } }}>
				<Drawer anchor="left" open variant="persistent">
					{content}
				</Drawer>
			</Box>
		</>
	);
};

NavBar.propTypes = {
	onMobileClose: PropTypes.func,
	openMobile: PropTypes.bool,
};

NavBar.defaultProps = {
	onMobileClose: () => {},
	openMobile: false,
};

export default NavBar;
